import doc                    from 'decorators/doc';
import model                  from 'decorators/model';
import InvoicePrivateApiModel from 'modelx/models/abstracts/InvoicePrivateApiModel';

@model.cacheDuration()
@model.staticLabel('BillingGroupType')
@model.urnResource('billing_group_type')
@doc.path('/billing_group_types/{?id}')
export default class BillingGroupTypeModel extends InvoicePrivateApiModel {
	public _filters: ModelFiltersExtended<{
		'reference': InvoiceBillingGroupTypeReference;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'label': string;
	}> = {};

	@doc.string declare label: string;
	@doc.string declare reference: InvoiceBillingGroupTypeReference;
}